import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.alabaster,
  borderColor: colors.overcast,
  linkColor: colors.pine
};
export default jumplink;